import { createRouter, createWebHistory } from 'vue-router';
import Login from '@/views/Login.vue';
import About from '@/views/About.vue';
import Apply from '@/views/Apply.vue';
import { useAuthStore } from '../stores/auth';

const routes = [
  {
    path: '/',
    component: () => import('../views/Home.vue'),
  },
  {
    path: '/login',
    component: Login,
  },
  {
    path: '/about',
    component: About,
  },
  {
    path: '/apply',
    component: Apply,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, _from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
        top: 80, // sticky header offset
      };
    }
    if (savedPosition) return savedPosition;
    return { top: 0 };
  },
});

router.beforeEach((to, _from, next) => {
  const authStore = useAuthStore();

  if (to.path === '/teacher-list' && !authStore.isAuthenticated) {
    next('/login');
  } else {
    next();
  }
});

export default router;
